import React from 'react';

import fetch from '../fetch';

import utils from '../../utils';

import {Tag ,Tooltip} from 'antd';
const prefixUrl = "listenPlan/import/"

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const columnsArray = [
    { type: 'selection' },
    { key: '$index', label: '序号' },
    {
        key: 'listenOrgName', width: 120,
        label: '听课部门名称'
    },
    {
        key: 'listenEmployeeCode', width: 120,
        label: '听课教师工号'
    },
    {
        key: 'listenEmployeeName', width: 120,
        label: '听课教师姓名',
    },
    {
        key: 'listenTypeName', width: 100,
        label: '听课类型'
    },
    {
        key: 'listenedEmployeeCode', width: 130,
        label: '被听课教师工号',
    },
    {
        key: 'listenedEmployeeName', width: 130,
        label: '被听课教师姓名'
    },
    {
        key: 'listenedTypeName', width: 100,
        label: '被听课类型'
    },
    {
        key: 'itemName', width: 100,
        label: '测评方',
    },
    {
        key: 'targetNames', width: 100,
        label: '指标',
    },
    {
        key: 'limitCountStr', width: 100,
        label: '可听课次数',
    },
    {
        key: 'expiryDateStr', width: 100,
        label: '截止日期',
    },
    {
        key: 'checkDesc',
        label:  '状态描述',
        width: 100,
        render: (d) => {
            return (
                <Tooltip title={d}>
                    <span>{d}</span>
                </Tooltip>
            )
        }
    },
    {
        key: 'checkFlag',
        label:  '状态',
        width: 100,
        render: (d) => {
            if (d === 2) {
                return <Tag color='#2db7f5'>检测通过</Tag>
            } else if (d === 3) {
                return <Tag color='#f50'>检测不通过</Tag>
            } else if (d === 4) {
                return <Tag color='#87d068'>导入成功</Tag>
            } else if (d === 5) {
                return <Tag color='#f50'>导入失败</Tag>
            }
        }
    }
]

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号' },
    {
        key: 'listenOrgName', width: 120,
        label: '听课部门名称'
    },
    {
        key: 'listenEmployeeCode', width: 120,
        label: '听课教师工号'
    },
    {
        key: 'listenEmployeeName', width: 120,
        label: '听课教师姓名',
    },
    {
        key: 'listenTypeName', width: 100,
        label: '听课类型'
    },
    {
        key: 'listenedEmployeeCode', width: 130,
        label: '被听课教师工号',
    },
    {
        key: 'listenedEmployeeName', width: 130,
        label: '被听课教师姓名'
    },
    {
        key: 'listenedTypeName', width: 100,
        label: '被听课类型'
    },
    {
        key: 'itemName', width: 100,
        label: '测评方',
    },
    {
        key: 'targetNames', width: 100,
        label: '指标',
    },
    {
        key: 'limitCountStr', width: 100,
        label: '可听课次数',
    },
    {
        key: 'expiryDateStr', width: 100,
        label: '截止日期',
    },
    {
        key: 'checkDesc',
        label:  '状态描述',
        width: 100,
        render: (d) => {
            return (
                <Tooltip title={d}>
                    <span>{d}</span>
                </Tooltip>
            )
        }
    },
    {
        key: 'checkFlag',
        label:  '状态',
        width: 100,
        render: (d) => {
            if (d === 2) {
                return <Tag color='#2db7f5'>检测通过</Tag>
            } else if (d === 3) {
                return <Tag color='#f50'>检测不通过</Tag>
            } else if (d === 4) {
                return <Tag color='#87d068'>导入成功</Tag>
            }
        }
    }
])

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    var params = [];
    var newKeyword = {};

    for (var i in keywords) {
        if (i === 'pageSize') {
            params.push(`pageSize=${keywords[i]}`);
        } else if (i === 'pageNum') {
            params.push(`pageNum=${keywords[i]}`);
        } else if (i === 'sort') {
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }

    return fetch.post(`${prefixUrl}query?` + params.join('&'), newKeyword)
        .then(response => {
            let extParams = response.payload.meta.extParams;
            let newArray = []
            
            if(extParams && extParams.relateCourse == 2){
                for (let i = 0; i < columnsArray.length; i++) {
                    if (columnsArray[i].key != 'itemName' && columnsArray[i].key != 'targetNames') {
                        newArray.push(columnsArray[i])
                    }
                }
            }
            return {
                data: response.payload.data,
                meta: response.payload.meta,
                headers: utils.columns(newArray.length > 0 ? newArray : columnsArray)
            };
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map((d, i) => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            meta: res.meta,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const importAudit = (keywords) => {
    return fetch.post(`${prefixUrl}importAudit`, keywords).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    }).catch(error => {
        return error;
    })
}

const removeByIds = (ids) => {
    return fetch.post(`${prefixUrl}deleteByIds`, ids).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const removeByQuery = (keywords) => {
    return fetch.post(`${prefixUrl}deleteByQuery`, keywords).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    removeByIds,
    removeByQuery,
    importAudit,
    getSelection
}
